import React from 'react'

import PointIcon from '@src/components/icons/Point'
import * as PATH from '@src/configs/paths'

interface IMilesTrackerProp {
    miles: number
}

const MilesTracker: React.FC<IMilesTrackerProp> = ({ miles }: IMilesTrackerProp) => {
    return (
        <a href={PATH.POINTS}>
            <div className='mt-2 flex items-center gap-2 rounded-lg bg-mach-mach-green/10 px-3 py-2'>
                <PointIcon data-tooltip-id='points-detail-tooltip' />
                <span className='text-sm text-mach-mach-green'>
                    You will earn {miles.toLocaleString('en-us', { maximumFractionDigits: 3 })}{' '}
                    {miles === 1 ? 'Mile' : 'Miles'} on this swap.
                </span>
            </div>
        </a>
    )
}

export default MilesTracker
